// extracted by mini-css-extract-plugin
export var aboveInput = "_md-0";
export var actionButton = "_md-5";
export var actionButtonContainer = "_md-1";
export var actionIcon = "_md-6";
export var aiInfoContainer = "_md-2";
export var attachmentWrapper = "_md-7";
export var bold = "_md-3";
export var checkIcon = "_md-8";
export var clickingRecipientBar = "_md-11";
export var commentThreadSwitch = "_md-a";
export var draftImage = "_md-b";
export var draftImageContainer = "_md-c";
export var draftImages = "_md-e";
export var editButton = "_md-g";
export var editor = "_md-f";
export var editorContainer = "_md-y";
export var editorErrorTooltipWrapper = "_md-9";
export var headerDivider = "_md-h";
export var icon = "_md-i";
export var info = "_md-j";
export var internal = "_md-n";
export var internalDivider = "_md-k";
export var internalMessage = "_md-l";
export var messageInputCard = "_md-m";
export var messageInputForm = "_md-o";
export var messageInputFormInternal = "_md-p";
export var options = "_md-q";
export var publicMessageCustomer = "_md-s";
export var publicMessageMerchant = "_md-r";
export var removeImageButton = "_md-d";
export var replyButtons = "_md-t";
export var showSignatureButton = "_md-u";
export var spinner = "_md-v";
export var verticalButtonDivider = "_md-4";
export var visibilitySelector = "_md-w";
export var warning = "_md-x";
export var wrappingText = "_md-z";
export var writingInternalNoteTopBorder = "_md-10";